import {min, sqrt} from "../math.js";

export default {
  draw(context, size) {
    const r = sqrt(size - min(size / 7, 2)) * 0.87559;
    context.moveTo(-r, 0);
    context.lineTo(r, 0);
    context.moveTo(0, r);
    context.lineTo(0, -r);
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/symbol/plus.js
// module id = 243
// module chunks = 0